import React from 'react';
import { useNavigate } from 'react-router-dom';
import VideoTemplate from '../components/home/VideoTemplate';

function HomePAge() {
  const navigate = useNavigate();
  return (
    <div style={{ padding: 24, maxWidth: '100%', overflowX: 'hidden', boxSizing: 'border-box' }}>
      <h1>Home Page</h1>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
        <button
          onClick={() => navigate('/create-video')}
          style={{ padding: '8px 12px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}
        >
          CreateYour Video
        </button>
      </div>
      <div style={{ marginTop: 24 }}>
        <VideoTemplate />
      </div>
    </div>
  );
}

export default HomePAge;
